export default __webpack_public_path__ + "static/media/Wristband of the Crawling Chaos.1564b0ab.jpg";